import values from "object.values";
// https://www.npmjs.com/package/object.values
// An ES2017 spec-compliant Object.values shim.
// Invoke its "shim" method to shim Object.values if it is unavailable or noncompliant.
if (!Object.values) {
  values.shim();
}
